export const AVAILABILITY_FILTER_VALUES = {
  ALL: 'ALL',
  MONDAY_MORNING: 'MONDAY_MORNING',
  MONDAY_LUNCH: 'MONDAY_LUNCH',
  MONDAY_AFTERNOON: 'MONDAY_AFTERNOON',
  TUESDAY_MORNING: 'TUESDAY_MORNING',
  TUESDAY_LUNCH: 'TUESDAY_LUNCH',
  TUESDAY_AFTERNOON: 'TUESDAY_AFTERNOON',
  WEDNESDAY_MORNING: 'WEDNESDAY_MORNING',
  WEDNESDAY_LUNCH: 'WEDNESDAY_LUNCH',
  WEDNESDAY_AFTERNOON: 'WEDNESDAY_AFTERNOON',
  THURSDAY_MORNING: 'THURSDAY_MORNING',
  THURSDAY_LUNCH: 'THURSDAY_LUNCH',
  THURSDAY_AFTERNOON: 'THURSDAY_AFTERNOON',
  FRIDAY_MORNING: 'FRIDAY_MORNING',
  FRIDAY_LUNCH: 'FRIDAY_LUNCH',
  FRIDAY_AFTERNOON: 'FRIDAY_AFTERNOON',
  SATURDAY_MORNING: 'SATURDAY_MORNING',
  SATURDAY_LUNCH: 'SATURDAY_LUNCH',
  SATURDAY_AFTERNOON: 'SATURDAY_AFTERNOON',
}

export const AVAILABILITY_FILTER_OPTIONS = Object.values(
  AVAILABILITY_FILTER_VALUES,
).map(value => ({
  name: value.replace('_', ' '),
  value: value,
}))
